/**
 * Requestor Group helpers.
 *
 * Groups let a client organize requestors into departments/business units,
 * each with an optional primary invoicer and CC requestors. When a requestor
 * is selected on a service, the invoice recipient and CC recipients are
 * derived from the requestor's group (or default to the requestor itself).
 */

/**
 * Resolve the invoice defaults for a selected requestor.
 *
 * @param {object|null} requestor - Selected requestor (may carry `Group`).
 * @returns {{ invoiceTo: object|null, ccRequestors: object[] }}
 *   - invoiceTo: the group's primary invoicer, or the requestor itself when
 *     the requestor has no group or the group has no primary invoicer.
 *   - ccRequestors: the group's CC requestors (empty when no group).
 */
export const getRequestorInvoiceDefaults = (requestor) => {
  const group = requestor?.Group;
  if (group) {
    return {
      invoiceTo: group.PrimaryInvoicer || requestor || null,
      ccRequestors: Array.isArray(group.CCRequestors)
        ? group.CCRequestors
        : [],
    };
  }
  return {
    invoiceTo: requestor || null,
    ccRequestors: [],
  };
};

const requestorGroupHelpers = {
  getRequestorInvoiceDefaults,
};

export default requestorGroupHelpers;
